module.exports = __webpack_public_path__ + "img/matthieu_d.e2be6ba3.png";